import PPDButton from "./button/PPDButton";
import ppd from "../assets/img/ppd.webp";
import { useEffect } from "react";

export default function PPD() {
  useEffect(() => {
    const handleScroll = () => {
      const viewportHeight = window.innerHeight;

      const ppdImage = document.getElementById("ppd_image");

      if (ppdImage.getBoundingClientRect().top < viewportHeight) {
        ppdImage.classList.add("animate-fadeInLeftScroll");
      }

      const ppdText = document.getElementById("ppd_text");

      if (ppdText.getBoundingClientRect().top < viewportHeight) {
        ppdText.classList.add("animate-fadeInRightScroll");
      }

      const ppdButton = document.getElementById("ppd_button");

      if (ppdButton.getBoundingClientRect().top < viewportHeight) {
        ppdButton.classList.add("visible");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="flex flex-col lg:flex-row my-20 mx-4 lg:mx-32 items-center">
      <div
        name="ppd_image"
        id="ppd_image"
        className="lg:w-1/2 lg:ml-10 lg:mt-0 mx-auto order-first lg:order-last"
      >
        <img
          src={ppd}
          alt="ppd"
          className="w-full max-w-[500px] h-auto mx-auto object-cover"
        />
      </div>
      <div className="text-center lg:text-left mt-10 lg:w-1/2 order-last lg:order-first">
        <div name="ppd_text" id="ppd_text">
          <h3 className="font-bold text-white text-3xl">
            Hatch Unique Dragons for Battle in PolarFi Pet Dragons
          </h3>
          <p className="text-slate-500 pb-10 pt-3">
            PolarFi presents Pet Dragons, an innovative Web3 experience where
            players can use FROST tokens to obtain mystical dragon eggs and
            hatch them into unique creatures. Each dragon possesses distinct
            powers and appearances, making it truly one of a kind. These dragons
            will be your powerful companions in Polar RPG battles, shaping your
            path to victory in the ever-evolving PolarFi universe.
          </p>
        </div>

        <div id="ppd_button" className=" animate-fadeIn">
          <PPDButton />
        </div>
      </div>
    </section>
  );
}
